export default function tour ($container, { initial, $refs }) {
  let currentScene = initial

  function onClickScene (e) {
    e.preventDefault()
    $refs.frame[0].src = e.currentTarget.getAttribute('data-href')
    window.history.replaceState({}, '', e.currentTarget.href)
    $refs.select[0].value = e.currentTarget.href

    updateMarker(e.currentTarget.getAttribute('data-title'))
  }

  function updateMarker (scene) {
    $container
      .querySelector(`a[data-title="${currentScene}"]`)
      .children[1].classList.remove('border-yellow')

    currentScene = scene

    $container
      .querySelector(`a[data-title="${currentScene}"]`)
      .children[1].classList.add('border-yellow')
  }

  $refs.scenes.forEach($scene => {
    if ($scene.getAttribute('data-href') === $refs.frame[0].src) {
      window.history.replaceState({}, '', $scene.href)
    }
    $scene.addEventListener('click', onClickScene)
  })

  $refs.select[0].addEventListener('change', () => {
    let $selectedOption = $refs.select[0].options[$refs.select[0].selectedIndex]
    $refs.frame[0].src = $selectedOption.getAttribute('data-href')
    window.history.replaceState({}, '', $selectedOption.value)

    updateMarker($selectedOption.getAttribute('data-title'))
  })

  return () => {
    $refs.scenes.forEach($scene => {
      $scene.removeventListener('click', onClickScene)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/components/tour.js